<template>
  <div class="cs-simple-search">
    <div class="cs-simple-search-content">
      <slot />
    </div>
    <el-button
      @click="refresh"
      class="cs-simple-search-refresh"
      icon="el-icon-refresh"
    ></el-button>
  </div>
</template>
<script>
export default {
  name: "CsSimpleSearch",
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
<style lang="scss" scoped>
.cs-simple-search {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .cs-simple-search-content {
    display: flex;
    flex-wrap: wrap;
  }
  .cs-simple-search-refresh {
    flex: 0 0 32px;
    height: 32px;
    text-align: center;
    padding: 0;
  }
}
</style>
